import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { TDepartment, fetchDepartments } from '../services/apicalls/consultation';
export const getDepartments = createAsyncThunk("consultation/fetchdepartments", async () => {
    try {
        let depts = await fetchDepartments()
        return depts.data;
    } catch (err) {
        return [];
    }
})
type TinitialState = {
    departments: TDepartment[]
}
const initialState: TinitialState = {
    departments: []
}
const consultation = createSlice({
    name: "consultation",
    initialState: initialState,
    reducers: {

    },
    extraReducers(builder) {
        builder.addCase(getDepartments.fulfilled, (state, action: PayloadAction<TDepartment[]>) => {
            state.departments = action.payload
        })
    }
})
export const { } = consultation.actions;
export default consultation.reducer;